import { initConfig, getMobileEnv } from "./wechat.js";

const AppId = "gh_6853edaf1b86";
const url = `pages/externalLinkLandscape/index?url=${encodeURIComponent(
  location.href
)}`;

function pcComponent(h) {
  return <div style={{ width: "100%", height: "100%" }}></div>;
}

function wxOpenTag(h) {
  return (
    <div class="qk-wx-mini-launch">
      <wx-open-launch-weapp
        id="wx-launch-btn"
        style={{
          overflow: "visible",
          width: "100%",
          height: "100%",
          display: "block",
          position: "relative",
        }}
        username={AppId}
        path={url}
      >
        <script
          type="text/wxtag-template"
          style="display: block !important;height: 100%;"
        >
          <div
            style={{
              width: "100%",
              height: "100%",
            }}
          ></div>
        </script>
      </wx-open-launch-weapp>
    </div>
  );
}

export default {
  name: "QkWxMiniLaunch",
  created() {},
  render(h) {
    const isWx = getMobileEnv().wechat;
    return isWx ? wxOpenTag.call(this, h) : pcComponent.call(this, h);
  },
};
